// extracted by mini-css-extract-plugin
export var addButton = "_jx-0";
export var border = "_jx-8";
export var check = "_jx-h";
export var danger = "_jx-6";
export var dropdownContainer = "_jx-1";
export var editModalBody = "_jx-j";
export var footerContainer = "_jx-i";
export var fullWidth = "_jx-a";
export var hide = "_jx-9";
export var icon = "_jx-3";
export var input = "_jx-7";
export var inputFlex = "_jx-b";
export var inputWrapper = "_jx-c";
export var manualFocus = "_jx-5";
export var optionButton = "_jx-4";
export var pillWrapper = "_jx-e";
export var pointer = "_jx-2";
export var showOverflow = "_jx-f";
export var tagsFlex = "_jx-d";
export var xButton = "_jx-g";